(function($) {
	function cosAngle(angleInDeg) {
		return Math.cos(angleInDeg * (Math.PI / 180));
	}

	$(document).ready(function() {
		// Hero
		(function() {
			const canv = document.getElementById('hero');

			// Return out if there isn't a hero canvas on this page
			if (!canv) return;

			// Get pixel density
			var scale = window.devicePixelRatio || 1;

			var canvW = 0;
			var canvH = 0;
			
			var ctx = canv.getContext('2d');
			var resize;
			var imageLoaded = false;
			var img = $('.hero-image').find('img').get(0);
		
			// Angle off to the left
			var leftAngle = cosAngle(65);
			
			// Angle off to the right
			var rightAngle = cosAngle(71);
			
			
			var outlineLeftAngle = cosAngle(67);
			var outlineRightAngle = cosAngle(72);

			
			var supportsGradient = typeof ctx.createLinearGradient === "function";
			
			
			function redraw() {
				// Clear canvas
				ctx.clearRect(0, 0, canv.height, canv.width);
				
				// Change default line cap
				ctx.lineCap = "square";
				
				// Set scale so we can use normal single density pixels
				ctx.scale(scale, scale);
				
				
				// Find the mid-point
				var midPoint = canvW/2;

				var originX = midPoint-200; // Our origin is offset from the midpoint
				var originY = canvH; //-shadow1height;
				
				
				if (imageLoaded) {
					// LAYER 1 --- Image
					// Get image dimensions
					var imgY = 0;
					var imgW = img.naturalWidth;
					var imgH = img.naturalHeight;

					var canvX = 0;
					var canvY = 0;

					// Image will be stretched height-wise, calculated the scale
					var imgScale = canvH/imgH;

					// Center align image
					var imgX = (((imgW*imgScale)-canvW)/2)/imgScale;

					// If the imgX is less than 0, it's not wide enough to fit in the space
					if (imgX < 0) {
						canvX = Math.abs(imgX)*imgScale;
						imgX = 0;
					}

					// Recalc widths
					imgW  -= (imgX*2);
					var imgCanvW = canvW - (canvX*2);

					// Draw image
					ctx.drawImage(img, imgX, imgY, imgW, imgH, canvX, canvY, imgCanvW, canvH);

					// LAYER 1 PART 2 --- Gradient fade edges
					ctx.globalCompositeOperation = 'destination-out';
					if (supportsGradient && canvX > 0) {
						var grad = ctx.createLinearGradient(canvX, 0, canvX+imgCanvW, 0);
						grad.addColorStop(0, '#000');
						grad.addColorStop(.1, 'transparent');
						grad.addColorStop(.9, 'transparent');
						grad.addColorStop(1, '#000');

						ctx.fillStyle = grad;
						ctx.fillRect(0, canvY, canvW, canvH);
					} else {
						ctx.fillStyle = 'transparent';
						ctx.fillRect(0, canvY, canvW, canvH);
					}
				}

				// LAYER 2 --- Overlay gradient
				ctx.globalCompositeOperation = 'normal';
				if (typeof ctx.createLinearGradient !== "function") {
					// Fallback solid colour for browsers (*cough*, IE) that don't support canvas gradients
					ctx.fillStyle = "rgba(0, 43, 73, 0.7)";
				} else {
					const grad = ctx.createLinearGradient(0, 0, canvH, canvH);
					grad.addColorStop(0, 'rgba(0,43,73,0.7)');
					grad.addColorStop(1, 'rgba(0,119,200,0.3)');
					
					ctx.fillStyle = grad;
				}
				ctx.fillRect(0, 0, canvW, canvH);


				// LAYER 3 --- Dark Overlay
				ctx.globalCompositeOperation = 'normal';
				ctx.fillStyle = 'rgba(0,43,73,0.4)';
				ctx.fillRect(0, 0, canvW, canvH);



				// LAYER 4 --- Light outline
				const outlineWidth = 42;
				ctx.globalCompositeOperation = "screen";
				ctx.beginPath();
				ctx.strokeStyle = "#002B49";
				ctx.lineWidth = outlineWidth;
				ctx.moveTo(0, originY-(outlineLeftAngle*originX));
				ctx.lineTo(originX, originY-(outlineWidth/2));
				ctx.lineTo(canvW,originY-((canvW-originX)*outlineRightAngle));
				ctx.stroke();


				// LAYER 5 --- Dark Overlay II
				ctx.globalCompositeOperation = 'normal';
				ctx.fillStyle = 'rgba(0,43,73,0.6)';
				ctx.fillRect(0, 0, canvW, canvH);
				
				
				// LAYER 6 --- Nav Gradient
				// Only for browsers (*cough* not IE) that support canvas gradients
				if (supportsGradient) {
					ctx.globalCompositeOperation = 'normal';

					const grad2 = ctx.createLinearGradient(0, 0, 0, 120);
					grad2.addColorStop(0, '#002B49');
					grad2.addColorStop(1, 'rgba(0, 43, 73, 0)');

					ctx.fillStyle = grad2;
					ctx.fillRect(0, 0, canv.width, 120);
				}


				// LAYER 7 --- Pin
				// Only if browser supports Path2D
				if (Path2D instanceof Object) {
					ctx.globalCompositeOperation = 'screen';

					var pathScale = 0.9;
					var path = new Path2D("m425.88685 74.638123c-97.42059-97.531913-255.3825-97.531913-352.81682 0-87.785592 87.885897-97.667647 253.379607-23.16793 352.807747l199.57634 288.55596 199.59007-288.55596c74.48599-99.42814 64.60393-264.92185-23.18166-352.807747z");

					ctx.save();
					/*
					Params:
					Horizontal Scale
					Vertical Skew
					Horizontal Skew
					Vertical Scale
					Horizontal Translate
					Vertical Translate
					*/
					ctx.transform(pathScale, 0, 0, pathScale, canvW/2 - (250*pathScale), 120);
					ctx.fillStyle = "rgba(0,43,73,.6)";
					ctx.fill(path);

					ctx.restore();
				}

				// MASK ALL LAYERS
				ctx.globalCompositeOperation = "destination-atop";
				ctx.fillStyle = "#002B49"; // This colour will be shown when the screen is so wide that the image doesn't fit
				ctx.beginPath();
				ctx.moveTo(0,0); // Top left
				ctx.lineTo(canvW,0); // Top right
				ctx.lineTo(canvW,originY-((canvW-originX)*rightAngle)); // Right side
				ctx.lineTo(originX,originY); // To the Origin
				ctx.lineTo(0, originY-(leftAngle*originX)); // Left side
				ctx.fill();
			}
			
			(resize = function() {
				// Set width to auto, else its fixed width forces the browser window wider
				canv.width = "auto";

				// Get width / height
				canvW = $(window).width();
				canvH = 880;

				// Scale for HiDPI/Retina
				canv.width = canvW*scale;
				canv.height = canvH*scale;

				// Set the actual width in CSS
				canv.style.width = canvW+"px";
				canv.style.height = canvH+"px";
				
				redraw();
			})();
			window.addEventListener('resize', resize);
			
			
			if (img.complete) {
				// If the image has already loaded, redraw now...
				imageLoaded = true;
				resize();
			}

			// ... Else, wait until the image has loaded
			img.addEventListener('load', function(e) {
				imageLoaded = true;
				resize();
			}, false);
		}());
		
		
		
		function Mask(params) {
			var canv = params.canvas;
			canv.className += ' init';
			
			var ctx = canv.getContext('2d');
			
			// Get pixel desity
			var scale = window.devicePixelRatio || 1;
			
			var canvW = window.innerWidth;
			var canvH = 0;
			
			var redraw = function() { 
				// Clear canvas
				ctx.clearRect(0, 0, canv.width, canv.height);
				
				// Match window width
				canvW = window.innerWidth;
				canv.width = canvW*scale;
				canv.style.width = canvW+"px";
			
				// Recalculate offset point
				var centerPoint = canvW/2;
				
				// There's only support for 1 layer
				var layer = params.layers[0];
				
				var offsetX = centerPoint + layer.offset;

				// Calculate left-most point
				var leftAngle = cosAngle(90-layer.angles[0]);
				var leftHeight = leftAngle*offsetX;


				// Calculate right-most point
				var rightAngle = cosAngle(90-layer.angles[1]);

				// Calc space between offset and right edge
				var widthRemainder = canvW-offsetX;
				var rightHeight = rightAngle*widthRemainder;


				// Which ever is the biggest, that'll be our canvas height
				var h = Math.max(leftHeight, rightHeight);

				// Add padding beneath
				h += 20;

				// Set canvas height
				canvH = h;
				canv.height = canvH*scale;
				canv.style.height = canvH+"px";


				// Set up path points
				var path = [
					[0, h-leftHeight-20],
					[offsetX, h-20],
					[canvW, h-rightHeight-20],
					[canvW, h],
					[0, h]
				];


				// Set scale so we can use normal single density pixels
				ctx.scale(scale, scale);
				
				// Shadow
				if (layer.shadow) {
					ctx.shadowColor = 'rgba(0,43,73,.25)';
					ctx.shadowBlur = 15;
					ctx.shadowOffsetX = 0;
					ctx.shadowOffsetY = 0;
				}

				// Set Background colour
				ctx.fillStyle = layer.background;
				ctx.beginPath();
				ctx.moveTo(path[0][0], path[0][1]);
				for (var i = 1; i < path.length; i++) {
					ctx.lineTo(path[i][0], path[i][1]);
				}
				ctx.fill();
			};
			
			redraw();
			
			$(window).on('resize orientationchange', function() {
				redraw();
			});
		}

		 
		// Create masks from HTML
		$('.mask:not(.init)').each(function() {
			var angles = ($(this).attr('data-angles') || "").split(',');
			var bg = $(this).attr('data-bg');
			var offset = parseInt($(this).attr('data-offset'), 10);
			var shadow = !!$(this).attr('data-shadow');
			
			new Mask({
				canvas: this,
				layers: [
					{
						background: bg,
						offset: offset,
						angles: angles,
						shadow: shadow
					}
				]
			})
		});
		
	});
}(jQuery));